import { Reveal } from "@/components/primitives";

const CLIENTS = [
  "Citi Bank",
  "Western Union",
  "Dave & Buster's",
  "HDFC Bank",
  "ABIL Group",
  "Oleander Farms",
  "Sterlight",
];

export default function ClientsMarquee() {
  return (
    <section className="border-b border-ink/10 bg-paper py-16 lg:py-20" data-testid="clients-marquee-section">
      <Reveal>
        <p className="px-6 text-center text-[11px] font-medium uppercase tracking-[0.3em] text-ink/50 lg:px-12">
          Trusted by pioneering companies
        </p>
      </Reveal>
      <div className="relative mt-10 overflow-hidden" data-testid="clients-marquee-track">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-paper to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-paper to-transparent" />
        <div className="marquee-track animate-marquee" style={{ animationDuration: "70s" }}>
          {[0, 1].map((dup) => (
            <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
              {CLIENTS.map((c) => (
                <span key={`${dup}-${c}`} className="mx-10 flex items-center gap-10 lg:mx-14">
                  <span className="whitespace-nowrap font-serif text-2xl text-ink/70 transition-colors duration-300 hover:text-maroon lg:text-3xl">
                    {c}
                  </span>
                  <span className="h-1.5 w-1.5 rotate-45 bg-navy/50" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
